import { TableCell, TableRow } from "@mui/material";
import React, { useState } from "react";
import Select from "react-select";
import { Dropdown, DropdownButton } from "react-bootstrap";
import BootstrapModal from "react-bootstrap/Modal";
import { toast } from "react-toastify";
import useLang from "../../../../Shared/hooks/useLanguage";
import { CrossIcon, DoneIcon } from "../../../../Shared/Icons";
import PermissionComponent, {
  getPermissionDisplayName,
} from "Shared/Common/Permissions/PermissionComponent";
import { SavePGXCompendiumTest } from "Services/Compendium/PgxCompendium";
import { reactSelectSMStyle, styles } from "Utils/Common";

function CompendiumTestRow({
  row,
  rows,
  index,
  setRows,
  onDelete,
  selectedBox,
  referenceLab,
  handleChange,
  disableDeleteBbutton,
  setIsAddButtonDisabled,
  handleChangeSelectedIds,
  GetAllCompendiumTestData,
  handleChangePerformingLab,
}: any) {
  const { t } = useLang();

  const [disableSaveBbutton, setDisableSaveBbutton] = useState(false);
  const [anchorEl, setAnchorEl] = React.useState({
    dropdown1: null,
    dropdown2: null,
    dropdown3: null,
    dropdown4: null,
  });

  const handleClose = (dropdownName: string) => {
    setAnchorEl({ ...anchorEl, [dropdownName]: null });
  };

  const handleDelete = (id: number) => {
    onDelete(id);
  };

  const [openalert, setOpenAlert] = useState(false);
  const handleCloseAlert = () => setOpenAlert(false);
  const handleClickOpen = (item: any, status: string) => {
    handleClose("dropdown2");
    setOpenAlert(true);
  };

  const getValues = (r: any) => {
    const updatedRows = rows.map((row: any) => {
      if (row.id === r.id) {
        return { ...row, rowStatus: true };
      }
      return row;
    });
    setRows(updatedRows);
  };

  const handlesave = async () => {
    try {
      if (row.performingLabId === 0) {
        toast.error(t("Performing Lab cannot be empty."));
        return;
      }
      if (!row.geneName || !row.geneName.trim()) {
        toast.error(t("Gene Name cannot be empty."));
        return;
      }

      if (!row.geneCode || !row.geneCode.trim()) {
        toast.error(t("Gene Code cannot be empty."));
        return;
      }
      setDisableSaveBbutton(true);
      const res = await SavePGXCompendiumTest(row);

      if (res?.data?.status === 200) {
        setDisableSaveBbutton(false);
        GetAllCompendiumTestData();
        setIsAddButtonDisabled(false);
        handleClose("dropdown2");
        toast.success("Added Successfully");
      } else {
        toast.error(res?.data?.message || "Something went wrong.");
        setIsAddButtonDisabled(false);
        setDisableSaveBbutton(false);
      }
    } catch (error) {
      console.error("Error in handlesave:", error);
      toast.error("An unexpected error occurred.");
    }
  };

  return (
    <>
      <TableRow className="h-30px">
        <TableCell>
          <label className="form-check form-check-sm form-check-solid d-flex justify-content-center">
            <input
              id={`ManageInventoryOpenExpandCheckBox_${row.id}`}
              className="form-check-input"
              type="checkbox"
              checked={selectedBox?.ids?.includes(row?.id)}
              onChange={(e) =>
                handleChangeSelectedIds(e.target.checked, row.id)
              }
            />
          </label>
        </TableCell>
        <TableCell>
          <div className="d-flex justify-content-center">
            {row?.rowStatus ? (
              <div className="gap-2 d-flex">
                <button
                  disabled={disableSaveBbutton}
                  id={`PGXCompendiumSave`}
                  onClick={() => {
                    handlesave();
                  }}
                  className="btn btn-icon btn-sm fw-bold btn-table-save btn-icon-light h-32px w-32px fas-icon-20px"
                >
                  <DoneIcon />
                </button>
                <button
                  id={`PGXCompendiumCancel`}
                  onClick={() => {
                    GetAllCompendiumTestData();
                    handleClose("dropdown2");
                    if (row?.id !== 0) {
                      const updatedRows = rows.map((r: any) => {
                        if (r.id === row?.id) {
                          return { ...r, rowStatus: false };
                        }
                        return r;
                      });
                      setRows(updatedRows);
                    } else {
                      const newArray = [...rows];
                      newArray.splice(index, 1);
                      setRows(newArray);
                      setIsAddButtonDisabled(true);
                    }
                  }}
                  className="btn btn-icon btn-sm fw-bold btn-table-cancel btn-icon-light h-32px w-32px fas-icon-20px"
                >
                  <CrossIcon />
                </button>
              </div>
            ) : (
              <div className="rotatebtnn">
                <DropdownButton
                  className="p-0 del-before btn btn-light-info btn-active-info btn-sm btn-action table-action-btn"
                  key="end"
                  id={`PGXCompendium3Dots_${row.id}`}
                  drop="end"
                  title={<i className="bi bi-three-dots-vertical p-0"></i>}
                >
                  <PermissionComponent
                    moduleName="PGX LIS"
                    pageName="Compendium Data"
                    permissionIdentifier="Edit"
                  >
                    {({ pageName, moduleName, permissionIdentifier }) => (
                      <Dropdown.Item
                        id={`PGXCompendiumEdit`}
                        className="w-auto"
                        eventKey="2"
                        onClick={() => {
                          getValues(row);
                        }}
                      >
                        <i className={"fa fa-edit text-primary mr-2"}></i>
                        {getPermissionDisplayName(
                          pageName,
                          moduleName,
                          permissionIdentifier,
                          "Edit"
                        )}
                      </Dropdown.Item>
                    )}
                  </PermissionComponent>

                  <PermissionComponent
                    moduleName="PGX LIS"
                    pageName="Compendium Data"
                    permissionIdentifier="Delete"
                  >
                    {({ pageName, moduleName, permissionIdentifier }) => (
                      <Dropdown.Item
                        id={`PGXCompendiumDelete`}
                        className="w-auto"
                        eventKey="2"
                        onClick={() => handleClickOpen(row, row.id)}
                      >
                        <i
                          className={"fa fa-trash text-danger mr-2 w-20px"}
                        ></i>
                        {getPermissionDisplayName(
                          pageName,
                          moduleName,
                          permissionIdentifier,
                          "Delete"
                        )}
                      </Dropdown.Item>
                    )}
                  </PermissionComponent>
                </DropdownButton>
              </div>
            )}
          </div>
        </TableCell>
        <TableCell
          id={`PGXCompendiumDisplayText_${row.id}`}
          sx={{ width: "max-content" }}
        >
          {row?.rowStatus ? (
            <div className="required d-flex">
              <div className="w-100">
                <Select
                  inputId={`BloodCompendiumDataCategorySetupGroup`}
                  menuPortalTarget={document.body}
                  theme={(theme) => styles(theme)}
                  options={referenceLab}
                  name="performingLabId"
                  styles={reactSelectSMStyle}
                  placeholder={t("Performing Lab")}
                  value={referenceLab.find(
                    (i: any) => i.value === row.performingLabId
                  )}
                  onChange={(e: any) => handleChangePerformingLab(row.id, e)}
                />
              </div>
            </div>
          ) : (
            row?.performingLab
          )}
        </TableCell>
        <TableCell
          id={`PGXCompendiumtestName_${row.id}`}
          sx={{ width: "max-content", whiteSpace: "nowrap" }}
        >
          {row?.rowStatus ? (
            <div className="required d-flex">
              <input
                id={`PGXCompendiumDisplayName`}
                type="text"
                placeholder={t("Gene Name")}
                name="geneName"
                className="form-control bg-white mb-lg-0 min-w-150px w-100 rounded h-30px"
                value={row?.geneName || ""}
                onChange={(e) =>
                  handleChange(e.target.name, e.target.value, row?.id)
                }
              />
            </div>
          ) : (
            row?.geneName
          )}
        </TableCell>

        <TableCell
          id={`PGXCompendiumtestName_${row.id}`}
          sx={{ width: "max-content", whiteSpace: "nowrap" }}
        >
          {row?.rowStatus ? (
            <div className="required d-flex">
              <input
                id={`PGXCompendiumDisplayName`}
                type="text"
                placeholder={t("Gene Code")}
                name="geneCode"
                className="form-control bg-white mb-lg-0 min-w-150px w-100 rounded h-30px"
                value={row?.geneCode || ""}
                onChange={(e) =>
                  handleChange(e.target.name, e.target.value, row?.id)
                }
              />
            </div>
          ) : (
            row?.geneCode
          )}
        </TableCell>
      </TableRow>

      <BootstrapModal
        show={openalert}
        onHide={handleCloseAlert}
        backdrop="static"
        keyboard={false}
      >
        <BootstrapModal.Header closeButton className="bg-light-primary m-0 p-5">
          <h4>{t("Delete Record")}</h4>
        </BootstrapModal.Header>
        <BootstrapModal.Body>
          {t("Are you sure you want to delete this record ?")}
        </BootstrapModal.Body>
        <BootstrapModal.Footer className="p-0">
          <button
            id={`PGXCompendiumModalCancel_${row.id}`}
            type="button"
            className="btn btn-secondary"
            onClick={handleCloseAlert}
          >
            {t("Cancel")}
          </button>
          <button
            id={`PGXCompendiumModalDelete_${row.id}`}
            type="button"
            className="btn btn-danger m-2"
            onClick={() => handleDelete(row?.id)}
            disabled={disableDeleteBbutton}
          >
            {t("Delete")}
          </button>
        </BootstrapModal.Footer>
      </BootstrapModal>
    </>
  );
}

export default CompendiumTestRow;
